import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';

import { ExemptVendor } from '../classes/models';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessVerificationApiErrorsService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  public getBusinessVerificationErrors(query: {} = {}): Observable<any> {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Client: () =>
            this.http.get(
              `/api/v2/company/${this.AuthService.getUserCompanyId()}/businessVerificationApiError/many`,
              { params: query }
            ),
          Admin: () =>
            this.http.get(`/api/v2/admin/businessVerificationApiError/many`, {
              params: query
            })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  public getBusinessVerificationErrorCount(query: {} = {}): Observable<number> {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<number>;
        } = {
          Admin: () =>
            this.http.get<number>(
              `/api/v2/admin/businessVerificationApiError/count`,
              { params: query }
            )
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }
}
